export default "__VITE_ASSET__Sw5QIwFIYi4x_gY32PsPXQ__"